export const getEmojiData = (state) => state.getIn(['app', 'cms', 'emoji', 'data']) || [];
